import { render, staticRenderFns } from "./AboutDialog.vue?vue&type=template&id=53268a70&scoped=true&"
import script from "./AboutDialog.vue?vue&type=script&lang=ts&"
export * from "./AboutDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AboutDialog.vue?vue&type=style&index=0&id=53268a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53268a70",
  null
  
)

export default component.exports